import { render, staticRenderFns } from "./CoaForm.vue?vue&type=template&id=5677776a&"
import script from "./CoaForm.vue?vue&type=script&lang=js&"
export * from "./CoaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports